import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Fato } from 'src/app/models/fato.model';
import { HelperService } from 'src/app/services/helper.service';
import { FatoService } from 'src/app/services/class/fato.service';
import { LoadingService } from 'src/app/services/loading.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpProgressEvent } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fato',
  templateUrl: './fato.component.html',
  styleUrls: ['./fato.component.scss']
})
export class FatoComponent implements OnInit {

  data: Fato = new Fato();

  buscarSubscription: Subscription;

  file: File;
  progress: number;

  constructor(
    public fatoService: FatoService,
    public helper: HelperService,
    public loadingService: LoadingService,
    public router: Router
  ) { }

  ngOnInit() {
    this.buscarData();
  }

  ngOnDestroy() {
    this.buscarSubscription.unsubscribe();
  }

  buscarData() {
    this.buscarSubscription = this.fatoService.get()
      .subscribe((res: Fato) => this.data = res);
  }

  submit(f: NgForm) {

    if (f.invalid) {
      this.helper.formMarkAllTouched(f);
      this.helper.openSnackBar('Preencha os campos requiridos, por favor!');
      return;
    }

    this.loadingService.present('Alterando...');

    this.fatoService.patch(this.data)
      .subscribe((res: any) => {
        this.helper.openSnackBar('Item alterado com sucesso.');
        this.router.navigate(['/']);
        this.loadingService.dismiss();
      }, e => {
        this.helper.openSnackBar(e.error);
        this.loadingService.dismiss()
      });

  }

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  onFileSelected(files) {
    this.file = files.item(0);
    this.loadingService.present('0%');
    this.submitImages(this.file, `/fato/imagem`).then((res: any) => {
      this.data.imagem = res.body;
      this.loadingService.dismiss();
    }).catch(() => {
      this.progress = 0;
      this.fileInput.nativeElement.value = '';
      this.loadingService.dismiss();
    });
  }

  submitImages(file: File, url: string) {
    if (!file) {
      return;
    }
    return new Promise((resolve, reject) => {
      this.fatoService.postFile(file, url, 'image')
        .subscribe((event: HttpProgressEvent | any) => {
          if (event.type === 4) {
            this.progress = 0;
            resolve(event);
          } else {
            this.progress = Math.round((event.loaded / event.total) * 100);
            if (isNaN(this.progress)) {
              this.progress = 100;
            }
            this.loadingService.title = `${this.progress}%`;
          }
        }, err => reject(err));
    });
  }

  removeImagem() {
    this.data.imagem = '';
  }

}
